import { render, staticRenderFns } from "./TableColumns.vue?vue&type=template&id=6a4774f6&scoped=true"
import script from "./TableColumns.vue?vue&type=script&lang=js"
export * from "./TableColumns.vue?vue&type=script&lang=js"
import style0 from "./TableColumns.vue?vue&type=style&index=0&id=6a4774f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4774f6",
  null
  
)

export default component.exports